import { useFormatDate } from "src/shared/hooks/useFormatDate"
import { useTimePulse } from "src/shared/hooks/useTimePulse"
import { CurrentdateProvider } from "src/shared/providers/CurrentdateProvider"

function DateSectionContent(): JSX.Element {
    const { formatCustomDate } = useFormatDate()
    const [now] = useTimePulse()

    return <p className="disp__date-section">{formatCustomDate(now, "D de MMMM de YYYY\nHH:mm:ss")}</p>
}

function DateSection(): JSX.Element {
    return (
        <CurrentdateProvider>
            <DateSectionContent />
        </CurrentdateProvider>
    )
}

export default DateSection